export const eventParticipationStatuses = [
  'present',
  'absent',
  'tentative',
  'late',
  'unknown',
  'standby',
  'missing',
  'removed',
] as const

type EventParticipationStatus = typeof eventParticipationStatuses[number]
export default EventParticipationStatus
